<div>
  <div class="fotos-container" *ngIf="bilder && bilder.length">
    <ion-img *ngFor="let p of bilder" class="bild" src="{{ p.src }}" appClick (clicked)="onBildClicked(p)"></ion-img>
  </div>

  <ion-button *ngIf="!readOnly"  expand="full" color="light" appClick (clicked)="onFotoAufnehmen($event)" class="icon-button-with-text button-md button-border">
    <ion-icon name="camera"></ion-icon> {{ 'Foto aufnehmen' | translate }}
  </ion-button>

  <ion-button *ngIf="!readOnly && galerieErlaubt" expand="full" color="light" appClick (clicked)="onFotoAuswaehlen($event)" class="icon-button-with-text button-md button-border">
    <ion-icon name="images"></ion-icon> {{ 'Foto aus Galerie auswählen' | translate }}
  </ion-button>
</div>